import {
  mapActions, mapState, mapGetters,
} from 'vuex';
import * as rootTypes from '@/store/types';
import * as campaignTypes from '@/modules/campaigns/store/types';

export default {
  computed: {
    ...mapState('campaigns', [
      'currencies',
    ]),
    ...mapGetters({
      currencyMap: rootTypes.GET_CURRENCY_MAP,
    }),
  },
  methods: {
    ...mapActions('campaigns', [
      campaignTypes.FETCH_CURRENCIES,
    ]),
    getFormattedMoneyAmount(amount, currency) {
      if (!amount) {
        return null;
      }
      const currencies = {
        left: [],
        right: [],
      };
      this.currencies.forEach((item) => {
        if (item.symbolPosition === 'PREFIX') currencies.left.push(item.symbolString);
        else currencies.right.push(item.symbolString);
      });
      return (currencies.left.includes(currency)) ? `${currency}${amount}` : `${amount}${currency}`;
    },
  },
  created() {
    if (this.currencies.length === 0) this.FETCH_CURRENCIES();
  },
};
